import { Routes } from '@angular/router'
import { HasRoleGuard } from '@elderbyte/ngx-auth'
import { ElderAccessDeniedComponent } from '@elderbyte/ngx-starter'
import { SettingsManagerComponent } from './domain/settings/settings-manager/settings-manager.component'
import { StorageNodeMdComponent } from './domain/storage/nodes/storage-node-md/storage-node-md.component'
import { StorageGroupBrowserComponent } from './domain/storage/storagegroups/storage-group-browser/storage-group-browser.component'
import { StorageGroupDetailSideComponent } from './domain/storage/storagegroups/storage-group-detail-side/storage-group-detail-side.component'
import { StorageGroupResolver } from './domain/storage/storagegroups/storage-group-resolver.service'
import { PackageBrowserComponent } from './domain/storage/packages/package-browser/package-browser.component'
import { PackageDetailSideComponent } from './domain/storage/packages/package-detail-side/package-detail-side.component'
import { PackageResolver } from './domain/storage/packages/package-resolver.service'
import { StorageManagerComponent } from './domain/storage/management/storage-manager/storage-manager.component'
import { StorageNodeBrowserIframeComponent } from './domain/storage/nodes/storage-node-browser-iframe/storage-node-browser-iframe.component'

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'app/storage',
    pathMatch: 'full',
  },

  {
    path: 'app',
    children: [
      {
        path: '',
        redirectTo: 'settings',
        pathMatch: 'full',
      },
      {
        path: 'accessdenied',
        component: ElderAccessDeniedComponent,
      },

      // Packages
      {
        path: 'packages',
        canActivate: [HasRoleGuard],
        component: PackageBrowserComponent,
        data: {
          roles: ['USER'],
          title: 'packages.title',
        },
      },

      // Storage Groups
      {
        path: 'storageGroups',
        canActivate: [HasRoleGuard],
        component: StorageGroupBrowserComponent,
        data: {
          roles: ['USER'],
          title: 'storageGroups.title',
        },
      },

      // Storage Layout Management
      {
        path: 'storage',
        canActivate: [HasRoleGuard],
        component: StorageNodeMdComponent,
        data: {
          roles: ['USER'],
          title: 'storage.title',
        },
      },
      {
        path: 'storage-nodes',
        canActivate: [HasRoleGuard],
        component: StorageNodeBrowserIframeComponent,
        data: {
          roles: ['USER'],
          title: 'storage.title',
        },
      },

      // Storage Management
      {
        path: 'storage-manager',
        canActivate: [HasRoleGuard],
        component: StorageManagerComponent,
        data: {
          roles: ['USER'],
          title: 'storage.management',
        },
      },

      // Settings
      {
        path: 'settings',
        canActivate: [HasRoleGuard],
        component: SettingsManagerComponent,
        data: {
          roles: ['USER'],
          title: 'settings.title',
        },
      },
    ],
  },

  /// OUTLET SIDE

  // Packages

  {
    path: 'packages/:id',
    outlet: 'side',
    component: PackageDetailSideComponent,
    canActivate: [HasRoleGuard],
    resolve: {
      package: PackageResolver,
    },
    data: {
      roles: ['USER'],
    },
  },

  // Storage Groups
  {
    path: 'storageGroups/:id',
    outlet: 'side',
    component: StorageGroupDetailSideComponent,
    canActivate: [HasRoleGuard],
    resolve: {
      storageGroup: StorageGroupResolver,
    },
    data: {
      roles: ['USER'],
    },
  },
]
